import React from 'react';
import { translate } from 'react-i18next';

class SidebarNoData extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const classes = `calendar-input select-a-day ${!this.props.active ? 'hide' : ''}`;
    return (
      <div className={classes}>
        <span className="pngs-CalendarCircle">
          <img alt="calendar icon" src="/images/pngs/CalendarCircle.png" />
        </span>
        <p>{this.props.t('SidebarNoData.select_a_day')}</p>
      </div>
    );
  }
}

export default translate()(SidebarNoData);
